import { useEffect, useState } from 'react';
import { testSuitesAPI, useAppDispatch } from '@app.raytd.com/store';
import type { SpecificationMembership } from '../utils/filterTestSuitesByView';

/**
 * Fetches the specification-to-view membership matrix for each given test
 * suite, keyed by suite id. Used to filter the manual "new test" flow's
 * specification list down to the suite's selected Test Suite View.
 */
export function useTestSuiteViewMemberships(testSuiteIds: number[]) {
  const dispatch = useAppDispatch();
  const [membershipBySuiteId, setMembershipBySuiteId] = useState<
    Record<number, SpecificationMembership | undefined>
  >({});

  const key = testSuiteIds.join(',');

  useEffect(() => {
    const subscriptions = testSuiteIds.map((testSuiteId) => {
      const subscription = dispatch(testSuitesAPI.endpoints.getTestSuiteViewMatrix.initiate(testSuiteId));
      subscription
        .unwrap()
        .then((result) => {
          setMembershipBySuiteId((prev) => ({ ...prev, [testSuiteId]: result.memberships }));
        })
        .catch(() => {
          // matrix fetch failure leaves this suite unfiltered (fail open)
        });
      return subscription;
    });

    return () => {
      subscriptions.forEach((subscription) => subscription.unsubscribe());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, key]);

  return membershipBySuiteId;
}
